import { Component } from 'react';
import PropTypes from 'prop-types';
import ScopeHeader from './ScopeHeader';
import { getIcon } from '../../utils/icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class ScopeGroupList extends Component {
  render() {
    const {
      scopes
    } = this.props;
    const keys = Object.keys(scopes);
    return keys.map(key => {
      const scope = scopes[key];
      return /*#__PURE__*/_jsxs("div", {
        "data-test-id": `authorize-scope-${scope.name}`,
        children: [/*#__PURE__*/_jsx(ScopeHeader, {
          icon: scope.icon || getIcon(scope.pictoIcon),
          use: "island",
          children: scope.translatedName
        }), /*#__PURE__*/_jsx("div", {
          className: "p-left-9",
          children: scope.translatedDescription
        })]
      }, key);
    });
  }
}
ScopeGroupList.propTypes = {
  scopes: PropTypes.object.isRequired
};